import * as angular from 'angular';

import { ComponentDefinition, PerformanceInformationDTO } from '../../models/';
import { IPerformanceService } from '../../services/';

class ServerLoadController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    performanceInformation: PerformanceInformationDTO;

    static $inject = ['performanceService'];

    constructor(
        private _performanceService: IPerformanceService) {
    }

    $onInit() {
        this.init();
    }

    private init(): void {
        this.isLoading = false;
        this.refresh();
    }

    refresh(): void {
        this.isLoading = true;

        this._performanceService.getEnvironment()
            .then((data: PerformanceInformationDTO) => {
                this.performanceInformation = data;
                this.isLoading = false;
            });
    }
}

export const wtServerLoad: ComponentDefinition = {
    componentId: 'wtServerLoad',
    controller: ServerLoadController,
    template: require('./serverLoad.component.html'),
    controllerAs: 'vm',
    bindings: {
        isLoading: '='
    }
};
